import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-phone-laptop-icon',
    templateUrl: './phone-laptop-icon.component.html',
    styleUrls: ['./phone-laptop-icon.component.scss']
})
export class PhoneLaptopIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 40;
    }
}
